<template>
  <div>
    <v-container fluid>
      <v-card class="card2">
        <v-flex class="flex">
          <v-card-text class="py-8">
            <pre><h2>What's new? <v-icon color="red">mdi-rocket-launch-outline</v-icon> </h2></pre>
            <v-expansion-panels focusable popout v-model="panel" mandatory class="mt-2">
              <v-expansion-panel
                v-for="(item,index) in items" 
                :key="index"
                expand  flat 
                color="primary"
              >
            <v-expansion-panel-title
            :color="paletteColor(index)" class="white--text">
                  <template v-slot:actions>
                    <v-icon color="white">
                      mdi-arrow-down-drop-circle-outline
                    </v-icon>
                  </template>
                  <v-col>
                    <v-row>
                      <h4> {{ item.releaseNumber }} </h4>
                    </v-row>
                    <v-row class="mt-4">
                      <pre><code>{{ item.releaseDate }}</code></pre>
                    </v-row>
                  </v-col>
                </v-expansion-panel-title>
                
                <v-expansion-panel-text> 
                  <v-list dense>
                    <div v-if="typeFeatureItems(index).length > 0" class="py-0"> 
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <h3><v-icon color="yellow darken-1">mdi-creation</v-icon> Feature</h3><br/>
                          </v-list-item-title>
                          <v-list-item-subtitle v-for="(child,i) in typeFeatureItems(index)" :key="i">
                            <pre class="black--text"> - {{ child.task }}</pre>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>

                    <v-divider v-if="typeBugItems(index).length > 0" class="my-4"></v-divider> 
                    <div v-if="typeBugItems(index).length > 0">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                      <h3><v-icon color="light-green">mdi-bug-outline</v-icon> Bugfixes</h3> <br/>
                          </v-list-item-title>
                          <v-list-item-subtitle v-for="child in typeBugItems(index)" :key="child.task">
                            <pre class="black--text"> - {{ child.task }}</pre>
                          </v-list-item-subtitle >
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels> 
          </v-card-text>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>

      <v-overlay :value="dialog">
        <v-dialog v-model="dialog" persistent width="300">
          <v-card color="#1976D2" dark>
            <v-card-text class="white--text">
              {{ $t('loadingpleasewait') }}
              <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import LogTrace from '@/api/function.js';
export default {
  name: 'MasterData',
  mixins: [LogTrace],
  data: () => ({
    listDataModel: [],
    today: null,
    dialog: false,
    options: {},
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    isFirst: true,
    menus: [],
    rules: {
      notRequired: [],
      required: [(value) => !!value || 'Required.'],
    },
    images: {
      edit: import('@/assets/edit1.png'),
      delete: import('@/assets/delete1.png'),
    },
    EditdialogUser: false,
    AdddialogUser: false,
    currentModelName: '',
    currentAPIVesion: '',
    currentID: null,
    statusDialog: false,
    statusText: '',
    typeConfirm: 'success',
    CurrentPromptPrice: 0,
    CurrentCompletionPrice: 0,
    currentModelDisplay: '',
    currentProvider: '',
    promptPriceTHB: 0,
    completionPriceTHB: 0,
    sortBy: [],
    sortDesc: [],
    DDProvider: ['Azure', 'Google'],
    items: [
      {
        releaseNumber: 'R',
        releaseDate: 'xx January 20xx',
        data: [
          {
            task: '',
            taskStatus: '',
          },
        ],
      },
    ],

    panel: 0,
    colorCache: {},
    palletteCache: {},
  }),
  async mounted() {
    let self = this;
    await self.GetDate();
    await self.GetReleaseNote();
  },
  computed: {
    typeFeatureItems() {
      return (index) => this.items[index].data.filter((item) => item.taskStatus === 'Feature');
    },
    typeBugItems() {
      return (index) => this.items[index].data.filter((item) => item.taskStatus === 'Bugfixes');
    },
  },
  methods: {
    randomColor(id) {
      const r = () => Math.floor(256 * Math.random());

      return this.colorCache[id] || (this.colorCache[id] = `rgb(${r()}, ${r()}, ${r()})`);
    },
    paletteColor(id) {
      const predefinedColors = [
        'blue darken-4', // Color1
        'blue darken-1', // Color2
      ];
      return this.palletteCache[id] || (this.palletteCache[id] = predefinedColors[id % predefinedColors.length]);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    async GetReleaseNote() {
      let self = this;
      self.dialog = true;
      await self.$call.GetReleaseNote(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.items = dataResponse.data;
          } else {
            self.items = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}
.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.v-expansion-panel {
  margin-top: 12px;
  border-radius: 3px;
}
</style>
